import apiVersion from '../_helpers/api-version';
import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig'

import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'
import httpStatus from 'http-status';

export const patientService = {
  retrieve,
  retrievePatient,
  retrieveMessages,
  retrievePatientAxSLinks,
}

function retrieveMessages(patientId) {
  const clientId = store.getState().client.id;

  const serviceURL = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient/${patientId}/conversation`;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: serviceURL,
  }).then((response) => {
    return response.data;
  })
}

function retrievePatientAxSLinks(patientId) {
  const clientId = store.getState().client.id;

  const serviceURL = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient/${patientId}/axs-links`

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: serviceURL,
  }).then((response) => {
    return response.data;
  })
}

function retrievePatient(patientId) {
  const clientId = store.getState().client.id;

  const serviceURL = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/patient/${patientId}`

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: serviceURL,
  }).then((response) => {
    return response.data;
  })
}

function retrieve(params = {}) {
  const clientId = store.getState().client.id;

  const baseURL = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}`
  const serviceURL = `${baseURL}/patient?${queryString.stringify(params)}`;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: serviceURL,
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data;
    }
  })
}